import { useState } from "react";

const TextComponent = ({ text }) => {
  const [isTrucate, setTruncate] = useState(true);

  return (
    <p
      onClick={() => setTruncate(!isTrucate)}
      style={{
        maxWidth: "250px",
      }}
      className={`${isTrucate && "text-truncate"} cursor-pointer`}
    >
      {text}
    </p>
  );
};

export default TextComponent;